
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/van/mercedes-sprinter",
      function () {
        return require("private-next-pages/wheels/van/mercedes-sprinter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/van/mercedes-sprinter"])
      });
    }
  